import { PopUpComponent } from "./PopUpComponent";
export default PopUpComponent;